<template src="./template.html"></template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'

  export default {
    props: {
      isTabActive: Boolean,
      showPayment: Boolean,
    },
    data() {
      return {
        voucherVal: '',
      }
    },
    computed: {
      ...mapGetters('vouchers', ['isPending']),
      ...mapState('vouchers', [
        'vouchers',
        'error',
      ]),
    },
    methods: {
      ...mapActions('vouchers', [
        'addVoucher',
        'removeVoucher',
      ]),
      async add(e) {
        e.preventDefault()
        if (this.voucherVal !== '') {
          const data = await this.addVoucher(this.voucherVal)

          if (!this.error) {
            this.toggleModal('C scc', data.title, data.msg)
            this.voucherVal = ''
          } else {
            this.toggleModal('C err', this.error.title, this.error.msg)
          }
        }
      },
      remove(e, voucher) {
        e.preventDefault()
        this.removeVoucher(voucher)
      },
    },
  }
</script>
